import ServicesPage from './ServicesWrapper';

export default ServicesPage;